import { render, staticRenderFns } from "./ExampleChips.vue?vue&type=template&id=6ef8bbce"
import script from "./ExampleChips.vue?vue&type=script&lang=js"
export * from "./ExampleChips.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports